import { Container, ShowFor, Size } from "@brightagency/headstart-common";
import React from "react";
import { NeedHelpNowCard } from "../../../constants/types/acf";
import { CarouselControls } from "../../molecules/CarouselControls";
import { useCardCarousel } from "../Carousel/controller";
import { NeedHelpCard } from "../NeedHelpCard";
import { Outer, Title, Copy, Inner } from "./styled";

interface Props {
    title: string;
    copy: string;
    cards: NeedHelpNowCard[];
}

export const NeedHelpNowCards: React.FC<Props> = props => {
    const { Carousel, scrollLeft, scrollRight, canScroll } = useCardCarousel(props.cards.length);

    return (
        <Outer>
            <Container>
                <Inner>
                    <div>
                        <Title>{props.title}</Title>
                        <Copy>{props.copy}</Copy>
                    </div>
                    {canScroll && (
                        <ShowFor size={Size.large}>
                            <CarouselControls onLeftClick={scrollLeft} onRightClick={scrollRight} />
                        </ShowFor>
                    )}
                </Inner>
            </Container>
            <Carousel>
                {props.cards.map((card, index) => (
                    <NeedHelpCard key={index} card={card} />
                ))}
            </Carousel>
        </Outer>
    );
};
